export default "__VITE_ASSET__BKDie2nc__"